<ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
    <!-- <li nz-submenu nzTitle="Configurations" nzIcon="control">
        <ul>
            <li nz-menu-item nzMatchRouter>
                <a routerLink="/configurations">Configurations</a>
            </li>
        </ul>
    </li> -->
    <li nz-submenu nzTitle="Admins" nzIcon="user">
        <ul>
            <li nz-menu-item nzMatchRouter>
                <a routerLink="/admins">Admins List</a>
            </li>
        </ul>
    </li>
    <li nz-submenu nzTitle="Clients" nzIcon="team">
        <ul>
            <li nz-menu-item nzMatchRouter>
                <a routerLink="/clients/list">Clients List</a>
            </li>
        </ul>
    </li>
</ul>